module.exports = __webpack_public_path__ + "img/item7.537d257a.png";